import { getItem } from "./generics";

export interface RucConsultation {
  found: boolean;
  ruc: string;
  businessName?: string;
  statusCode?: string;
  statusDescription?: string;
  electronicInvoicing?: boolean;
  responseCode: string;
  responseMessage?: string;
}

export const consultRuc = (taxPayerId: number, ruc: string) =>
  getItem<RucConsultation>(
    `/tax_payers/${taxPayerId}/consult_ruc/`,
    new Map([["ruc", ruc]]),
  );
